var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DebouncedInput",class:_vm.status},[_c('WInput',{attrs:{"name":_vm.id,"placeholder":_vm.placeholder.toString(),"min":_vm.min,"max":_vm.max,"type":"number","align":_vm.align},model:{value:(_vm.localStringValue),callback:function ($$v) {_vm.localStringValue=$$v},expression:"localStringValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }